import { render, staticRenderFns } from "./SickLeaveRequest.vue?vue&type=template&id=d9d32a1a&scoped=true&"
import script from "./SickLeaveRequest.vue?vue&type=script&lang=ts&"
export * from "./SickLeaveRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d32a1a",
  null
  
)

export default component.exports